module.exports = __webpack_public_path__ + "img/_location.10259618.svg";